<template>
  <div id="wrap">
    <!-- 第一部分轮播图样式 -->
    <div class="rotationChart">
      <!-- 背景banner -->
      <div class="banner"></div>
      <!-- 轮播图 -->
      <swiper :options="swiperOption" ref="mySwiper" class="mySwiper">
        <!-- slides -->
        <swiper-slide class="mySwiper-item">
          <a href="javascript:;">
            <img
              src="../../assets/imgs/banner.png"
              class="ani"
              swiper-animate-effect="slideInRight"
              swiper-animate-duration="0.8s"
            />
          </a>
        </swiper-slide>
        <swiper-slide class="mySwiper-item">
          <a href="javascript:;">
            <img
              src="../../assets/imgs/banner.png"
              class="ani"
              swiper-animate-effect="slideInRight"
              swiper-animate-duration="0.8s"
            />
          </a>
        </swiper-slide>
        <swiper-slide class="mySwiper-item">
          <a href="javascript:;">
            <img
              src="../../assets/imgs/banner.png"
              class="ani"
              swiper-animate-effect="slideInRight"
              swiper-animate-duration="0.8s"
            />
          </a>
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <!-- 轮播图下方展示栏 -->
      <div class="displayBar animate-top">
        <div>
          <img src="../../assets/imgs/11 .png" alt="背景图" />
          <span class="title">自主研发的隐私粉碎技术</span>
          <span class="text">同城帮拥有自主研发的隐私粉碎技术，全方位保护二手数码设备的安全流通</span>
        </div>
        <div>
          <img src="../../assets/imgs/22.png" alt="背景图" />
          <span class="title">经验丰富的运营研发团队</span>
          <span class="text">同城帮团队来自于腾讯、阿里、苏宁、亚马逊等名企背景，拥有3C类目落地操盘经验</span>
        </div>
        <div>
          <img src="../../assets/imgs/33.png" alt="背景图" />
          <span class="title">店网互通的全链接OMO解决方案</span>
          <span class="text">同城帮已为中国移动、苏宁、苹果等客户提供场景化零售服务，致力于提升数码品类销售效率</span>
        </div>
      </div>
    </div>

    <!-- 第二部分视频样式 -->
    <div class="showVideo-bg">
      <div class="showVideo">
        <!-- 左边文字 -->
        <div class="left">
          <!-- title -->
          <div class="left-top publicStyle-title">
            <div>
              <span></span>
              <span></span>
            </div>
            <div>一站式引擎，全流程服务</div>
          </div>
          <div
            class="left-bottom"
          >同城帮作为国内专业的循环经济产业服务商，已完整覆盖从回收、质检、零售、供应链四大场景解决方案服务，长期为品牌厂商、终端渠道商、平台商、运营商等大型客户提供一站式以旧换新解决方案服务，旗下拥有“同城帮”“苏宁二手”“同城帮优品”“轻松换”“天机汇”等多个子品牌，涵盖了从C端回收、渠道回收、B2C、B2B、Saas等前台业务形态，建立了覆盖全国的二手机全场景流通分销网络。依托同城帮通过ISO9001认证的标准化质检流程和质检标准、隐私粉碎技术、售前售后客服质检体系、备件库等中台品控系统，为合作方提供全方位的二手闲置业务运营服务</div>
        </div>
        <!--右边视频部分 -->
        <div class="right">
          <div class="videoWrap">
            <video-player
              class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions"
              @pause="onPlayerPause($event)"
              @ended="onPlayerEnded($event)"
              @play="onPlayerPlay($event)"
            ></video-player>
          </div>
          <!-- 视频按钮 -->
          <img
            v-show="isShowBotton"
            class="playBtn"
            src="../../assets/imgs/播放按钮.png"
            alt
            @click="handlePlay"
          />
        </div>
      </div>
    </div>

    <!-- 第三部分信息栏 -->
    <div class="informationBar">
      <!-- title -->
      <div class="publicStyle-title">
        <div>
          <span></span>
          <span></span>
        </div>
        <div>三大循环经济场景持续聚焦</div>
      </div>
      <!-- 点击区域 -->
      <ul class="tabBar">
        <li class="tabBar-one tabBar-public">
          <div
            :class="{active:showContentData[0].isHighlight}"
            @mouseenter="onMouseEnter(0)"
            @mouseleave="onMouseLeave(0)"
            @click="handeleClick(0)"
          >
            <!-- <img :src="isHover==false?'../../assets/imgs/运营商icon2.png':'../../assets/imgs/运营商icon1.png'" /> -->
            <img src="../../assets/imgs/运营商icon2.png" alt="图片" v-show="!isHover1" />
            <img src="../../assets/imgs/运营商icon1.png" alt="图片" v-show="isHover1" />
            <span v-show="showContentData[0].isHighlight"></span>
          </div>
          <div>运营\渠道\品牌商解决方案</div>
        </li>
        <li class="tabBar-two tabBar-public">
          <div
            :class="{active:showContentData[1].isHighlight}"
            @mouseenter="onMouseEnter(1)"
            @mouseleave="onMouseLeave(1)"
            @click="handeleClick(1)"
          >
            <img src="../../assets/imgs/产业icon2.png" v-show="!isHover2" />
            <img src="../../assets/imgs/产业icon1.png" v-show="isHover2" />
            <span v-show="showContentData[1].isHighlight"></span>
          </div>
          <div>产业交易平台</div>
        </li>
        <li class="tabBar-three tabBar-public">
          <div
            :class="{active:showContentData[2].isHighlight}"
            @mouseenter="onMouseEnter(2)"
            @mouseleave="onMouseLeave(2)"
            @click="handeleClick(2)"
          >
            <img src="../../assets/imgs/3cicon2.png" v-show="!isHover3" />
            <img src="../../assets/imgs/3cicon1.png" v-show="isHover3" />
            <span v-show="showContentData[2].isHighlight"></span>
          </div>
          <div>消费者3C服务</div>
        </li>
      </ul>
      <!-- 显示区域 -->
      <div class="showContent">
        <div class="left">
          <img :src="showContentObj[0].img" alt />
        </div>
        <div class="right">
          <div class="title">{{showContentObj[0].title}}</div>
          <div class="text">{{showContentObj[0].text}}</div>
        </div>
      </div>
    </div>

    <!-- 第四部分回收信息 -->
    <div class="recoveryInformation-bg">
      <div class="recoveryInformation">
        <!-- title -->
        <div class="publicStyle-title">
          <div>
            <span></span>
            <span></span>
          </div>
          <div>3C回收业务开放平台</div>
        </div>
        <!-- 展示栏 -->
        <ul class="recoveryInformation-ul">
          <li :class="{'showBorder':recoveryData[0].isShowBoeder}" @click="addBorder(0)">
            <a href="javascript:;">
<!--              <img src="https://p0.ssl.qhimg.com/t018f49cd1ecea2ebcb.jpg" alt="回收" />-->
              <img src="https://p3.ssl.qhmsg.com/t01ebe8b4e67062b13c.jpeg" alt="回收" />
            </a>
            <div>
              <div class="title">同城帮门店回收开放平台</div>
              <div
                class="text"
              >同城帮回收业务现已在全国范围开放加盟,签约商家门店可以获得同城帮系统技术支持、回收终端设备、回收质检与佣金结算服务，助您快速部署手机回收业务,一次投资，坐享收益</div>
            </div>
          </li>
          <li :class="{'showBorder':recoveryData[1].isShowBoeder}" @click="addBorder(1)">
            <a href="javascript:;">
              <img src="../../assets/imgs/suningyigou.jpg" alt="回收" />
            </a>
            <div>
              <div class="title">苏宁二手分销联盟</div>
              <div class="text">同城帮拥有苏宁二手品牌，同时赋能线上线下三方渠道货源、品牌、销售指导与售后服务专业一条龙分销业务。为三方快速打通二手分销上下游服务。</div>
            </div>
          </li>
          <li :class="{'showBorder':recoveryData[2].isShowBoeder}" @click="addBorder(2)">
            <a href="javascript:;">
              <img src="../../assets/imgs/tianjihui.jpg" alt="回收" />
            </a>
            <div>
              <div class="title">苏宁二手分销联盟</div>
              <div
                class="text"
              >天机汇B2B是专为二手流通领域的卖场、零售商户、维修商户提供的二手设备批量交易平台。主要提供二手机行情、报价、采购、拍卖等B端交易撮合服务</div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 第五部分分布信息 -->
    <div class="distributionInformation">
      <!-- 左边 -->
      <div class="left">
        <!-- title -->
        <div class="publicStyle-title">
          <div>
            <span></span>
            <span></span>
          </div>
          <div>覆盖全国数码回收网络</div>
        </div>
        <!-- 描述 -->
        <div class="left-title">13大回收中心，每日20万+二手机吞吐量</div>
        <!-- contnet -->
        <ul class="left-content">
          <li>
            <span>
              6000
              <span>家</span>
            </span>
            <span>线下门店</span>
          </li>
          <li>
            <span>
              13
              <span>城</span>
            </span>
            <span>城市回收中心</span>
          </li>
          <li>
            <span>
              500
              <span>+</span>
            </span>
            <span>合作伙伴</span>
          </li>
          <li>
            <span>
              20
              <span>万+</span>
            </span>
            <span>日均访问量</span>
          </li>
        </ul>
      </div>
      <!-- 右边 -->
      <div class="right">
        <!-- <img src="../../assets/imgs/地图.png" alt /> -->
        <div class="myEcharts"></div>
      </div>
    </div>

    <!-- 第六部分 新闻动态-->
    <div class="newsInformation-bg">
      <div class="newsInformation">
        <!-- title -->
        <div class="publicStyle-title">
          <div>
            <span></span>
            <span></span>
          </div>
          <div>新闻动态</div>
        </div>
        <!-- 下方展示区 -->
        <ul class="newsInformation-content">
          <li>
            <div class="left">
              <img src="https://p4.ssl.qhimg.com/t018d2998cebdd233ba.png" alt />
            </div>
            <ul class="right">
              <li>二手机中的隐私安全：揭秘电子产品回收的...</li>
              <li>隐私粉碎则是将所有的路径挨个堵住，让任何技术都无路可走，从而无法看到遗存下来的信息。</li>
              <li>
                <i class="iconfont icon-zhongbiao"></i> 2019-12-12
              </li>
            </ul>
          </li>
          <li>
            <div class="left">
              <img src="https://p0.ssl.qhimg.com/t0152c986b9abb489f1.png" alt />
            </div>
            <ul class="right">
              <li>专访同城帮CEO郑立群：如何解决手机...</li>
              <li>“我们的同行在打广告的时候，每年都要花费几个亿来打广告，那么老百姓听到了吗？老百姓绝对听到了。为什么不采取行动呢？一定是有“什么东西”拦住了他们。我觉得是在隐私安全这个方面。”</li>
              <li>
                <i class="iconfont icon-zhongbiao"></i> 2019-12-12
              </li>
            </ul>
          </li>
          <li>
            <div class="left">
              <img src="https://p3.ssl.qhimg.com/t018c703f0bdc6f2e05.png" alt />
            </div>
            <ul class="right">
              <li>同城帮战略合作伙伴苏宁首家快修店在京亮相</li>
              <li>7月20日，苏宁快修全国首家全新升级的售后服务馆在慈云寺云店正式亮相，全新的视觉形象、更舒适的体验空间、更规范、透明的服务再次成为行业的标杆。</li>
              <li>
                <i class="iconfont icon-zhongbiao"></i> 2019-12-12
              </li>
            </ul>
          </li>
          <li>
            <div class="left">
              <img src="https://p0.ssl.qhimg.com/t017bb0d41d889ed533.png" alt />
            </div>
            <ul class="right">
              <li>同城帮让回忆有价值，让回收更安全</li>
              <li>日前，作为线上、线下结合，提供「一站式」回收服务的「同城帮」，将带你透过一张张旧照片，慢慢勾起你慢回忆杀，开启你的回忆之旅。6 月 5 日-12 日同城帮联合苏宁易购，努比亚、华为、美图、诺基亚、海信、荣耀、小米等知名手机品牌联合发起 # 让回忆有价值 # 活动。6 月 8 日-12 日，前往到苏宁指定线下门店参与 # 让回忆有价值 # 活动，活动期间，回收你的旧手机即可用惠普专用照片打印机免费打印照片，同时同城特别准备了一万张 50 元购机券以及以旧换新再补贴 100 元的活动福利。</li>
              <li>
                <i class="iconfont icon-zhongbiao"></i> 2019-12-12
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <!--  合作伙伴 -->
    <div class="cooperativePartner">
      <!-- title -->
      <div class="publicStyle-title">
        <div>
          <span></span>
          <span></span>
        </div>
        <div>合作伙伴</div>
      </div>
      <!-- 内容区 -->
      <div class="cooperativePartner-content">
        <div class="img" v-for="(item,index) in cooperativePartnerImg" :key="index">
          <img :src="item" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script src="js/swiper.min.js"></script>
<script>
import * as swiperAni from "../../assets/js/swiper.animate.min";
import china from "../../assets/js/china";
export default {
  data() {
    return {
      // 轮播图配置
      swiperOption: {
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        direction: "horizontal", // 横向切换选项
        autoplay: {
          // 循环模式选项
          delay: 5500 //5秒切换一次
        },
        effect: "fade", //轮播样式
        on: {
          init: function() {
            swiperAni.swiperAnimateCache(this);
            swiperAni.swiperAnimate(this);
          },
          slideChange: function() {
            swiperAni.swiperAnimate(this);
            var banner = document.querySelector(".banner");
            banner.classList.add("animate");
          }
        }
      },
      swiperOption1: {},

      carouselIndex: 0,

      // 回收业务数据
      recoveryData: [
        { isShowBoeder: false },
        { isShowBoeder: false },
        { isShowBoeder: false }
      ],
      // 是否移入
      isHover1: true,
      isHover2: false,
      isHover3: false,
      // 循环经济数据
      showContentData: [
        {
          img: "http://p8.qhimg.com/t01b442910bbfa62da3.png",
          title: "运营商/渠道商/品牌商解决方案",
          text:
            "同城帮已完整覆盖了从回收、质检、零售、供应链等四大场景解决方案服务，长期为品牌厂商、终端渠道商、平台商、运营商等大型客户提供一站式以旧换新解决方案服务，依托同城帮经过ISO9001认证的标准化质检流程和质检标准、售前售后客服质检体系、备件库等中台品控系统，可以为合作方提供全方位的以旧换新业务运营服务。",
          isHighlight: true
        },
        {
          img: "http://p3.qhimg.com/t015e3ee2424f630b78.png",
          title: "产业交易平台",
          text:
            "同城帮过往五年来，建立了覆盖全国的二手机全场景流通分销网络，旗下的”天机汇“B2B交易平台年均撮合交易数十亿元，已成为二手数码商家必不可少的批量采销工具.",
          isHighlight: false
        },
        {
          img: "http://p5.qhimg.com/t01d0504b795c920eb8.png",
          title: "消费者3C服务",
          text:
            "同城帮依托自主研发的隐私粉碎技术，通过旗下同城帮优品与安全回收两大业务，长期为消费者提供安全放心、便捷实惠的二手机回收与消费服务。",
          isHighlight: false
        }
      ],
      // 视频配置
      playerOptions: {
        width: "200px",
        height: "100px",
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: true,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            //类型
            type: "video/webm",
            //url地址
            src: require("../../assets/video/3.webm")
            // src: "http://vjs.zencdn.net/v/oceans.mp4"
          }
        ],
        //你的封面地址
        poster: require("../../assets/imgs/bj.jpg"),
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }
      },
      isShowBotton: true,
      // 地图城市数据
      cityData: [
        // 假数据
        { name: "海门", value: 9 },
        { name: "鄂尔多斯", value: 12 },
        { name: "招远", value: 12 },
        { name: "舟山", value: 12 },
        { name: "齐齐哈尔", value: 14 },
        { name: "盐城", value: 15 },
        { name: "赤峰", value: 16 },
        { name: "青岛", value: 18 },
        { name: "乳山", value: 18 },
        { name: "金昌", value: 19 },
        { name: "泉州", value: 21 },
        { name: "莱西", value: 21 },
        { name: "日照", value: 21 },
        { name: "胶南", value: 22 },
        { name: "南通", value: 23 },
        { name: "拉萨", value: 24 },
        { name: "云浮", value: 24 },
        { name: "梅州", value: 25 },
        { name: "文登", value: 25 },
        { name: "攀枝花", value: 25 },
        { name: "威海", value: 25 },
        { name: "承德", value: 25 },
        { name: "厦门", value: 26 },
        { name: "汕尾", value: 26 },
        { name: "潮州", value: 26 },
        { name: "丹东", value: 27 },
        { name: "太仓", value: 27 },
        { name: "曲靖", value: 27 },
        { name: "烟台", value: 28 },
        { name: "福州", value: 29 },
        { name: "瓦房店", value: 30 },
        { name: "即墨", value: 30 },
        { name: "抚顺", value: 31 },
        { name: "玉溪", value: 31 },
        { name: "张家口", value: 31 },
        { name: "阳泉", value: 31 },
        { name: "莱州", value: 32 },
        { name: "湖州", value: 32 },
        { name: "汕头", value: 32 },
        { name: "昆山", value: 33 },
        { name: "宁波", value: 33 },
        { name: "湛江", value: 33 },
        { name: "揭阳", value: 34 },
        { name: "荣成", value: 34 },
        { name: "连云港", value: 35 },
        { name: "葫芦岛", value: 35 },
        { name: "常熟", value: 36 },
        { name: "东莞", value: 36 },
        { name: "河源", value: 36 },
        { name: "淮安", value: 36 },
        { name: "泰州", value: 36 },
        { name: "南宁", value: 37 },
        { name: "营口", value: 37 },
        { name: "惠州", value: 37 },
        { name: "江阴", value: 37 },
        { name: "蓬莱", value: 37 },
        { name: "韶关", value: 38 },
        { name: "嘉峪关", value: 38 },
        { name: "延安", value: 38 },
        { name: "太原", value: 39 },
        { name: "清远", value: 39 },
        { name: "中山", value: 39 },
        { name: "昆明", value: 39 },
        { name: "寿光", value: 40 },
        { name: "盘锦", value: 40 },
        { name: "长治", value: 41 },
        { name: "珠海", value: 42 },
        { name: "宿迁", value: 43 },
        { name: "咸阳", value: 43 },
        { name: "铜川", value: 44 },
        { name: "平度", value: 44 },
        { name: "佛山", value: 44 },
        { name: "海口", value: 44 },
        { name: "江门", value: 45 },
        { name: "章丘", value: 45 },
        { name: "肇庆", value: 46 },
        { name: "大连", value: 47 },
        { name: "临汾", value: 47 },
        { name: "吴江", value: 47 },
        { name: "石嘴山", value: 49 },
        { name: "苏州", value: 50 },
        { name: "茂名", value: 50 },
        { name: "嘉兴", value: 51 },
        { name: "长春", value: 51 },
        { name: "胶州", value: 52 },
        { name: "银川", value: 52 },
        { name: "张家港", value: 52 },
        { name: "三门峡", value: 53 },
        { name: "锦州", value: 54 },
        { name: "南昌", value: 54 },
        { name: "柳州", value: 54 },
        { name: "三亚", value: 54 },
        { name: "自贡", value: 56 },
        { name: "吉林", value: 56 },
        { name: "阳江", value: 57 },
        { name: "泸州", value: 57 },
        { name: "西宁", value: 57 },
        { name: "宜宾", value: 58 },
        { name: "呼和浩特", value: 58 },
        { name: "大同", value: 58 },
        { name: "镇江", value: 59 },
        { name: "桂林", value: 59 },
        { name: "张家界", value: 59 },
        { name: "宜兴", value: 59 },
        { name: "北海", value: 60 },
        { name: "金坛", value: 62 },
        { name: "东营", value: 62 },
        { name: "牡丹江", value: 63 },
        { name: "遵义", value: 63 },
        { name: "绍兴", value: 63 },
        { name: "扬州", value: 64 },
        { name: "常州", value: 64 },
        { name: "潍坊", value: 65 },
        { name: "台州", value: 67 },
        { name: "滨州", value: 70 },
        { name: "贵阳", value: 71 },
        { name: "无锡", value: 71 },
        { name: "本溪", value: 71 },
        { name: "克拉玛依", value: 72 },
        { name: "渭南", value: 72 },
        { name: "马鞍山", value: 72 },
        { name: "宝鸡", value: 72 },
        { name: "焦作", value: 75 },
        { name: "句容", value: 75 },
        { name: "徐州", value: 79 },
        { name: "衡水", value: 80 },
        { name: "包头", value: 80 },
        { name: "绵阳", value: 80 },
        { name: "乌鲁木齐", value: 70 },
        { name: "枣庄", value: 84 },
        { name: "淄博", value: 85 },
        { name: "鞍山", value: 86 },
        { name: "溧阳", value: 86 },
        { name: "库尔勒", value: 86 },
        { name: "安阳", value: 90 },
        { name: "开封", value: 20 },
        { name: "德阳", value: 93 },
        { name: "温州", value: 47 },
        { name: "九江", value: 96 },
        { name: "邯郸", value: 98 },
        { name: "临安", value: 99 },
        { name: "兰州", value: 99 },
        { name: "沧州", value: 80 },
        { name: "临沂", value: 80 },
        { name: "南充", value: 80 },
        { name: "天津", value: 80 },
        { name: "富阳", value: 80 },
        { name: "泰安", value: 80 },
        { name: "诸暨", value: 80 },
        { name: "哈尔滨", value: 70 },
        { name: "聊城", value: 45 },
        { name: "芜湖", value: 30 },
        { name: "唐山", value: 30 },
        { name: "平顶山", value: 47 },
        { name: "邢台", value: 30 },
        { name: "德州", value: 55 },
        { name: "济宁", value: 15 },
        { name: "荆州", value: 25 },
        { name: "宜昌", value: 35 },
        { name: "义乌", value: 38 },
        { name: "丽水", value: 20 },
        { name: "洛阳", value: 33 },
        { name: "秦皇岛", value: 44 },
        { name: "株洲", value: 27 },
        { name: "石家庄", value: 24 },
        { name: "莱芜", value: 50 },
        { name: "常德", value: 33 },
        { name: "保定", value: 36 },
        { name: "湘潭", value: 25 },
        { name: "金华", value: 50 },
        { name: "岳阳", value: 30 },
        { name: "长沙", value: 45 },
        { name: "衢州", value: 20 },
        { name: "廊坊", value: 60 },
        { name: "菏泽", value: 40 },
        { name: "合肥", value: 55 },
        { name: "大庆", value: 50 },

        {
          name: "成都",
          value: 150
        },
        {
          name: "西安",
          value: 150
        },
        {
          name: "重庆",
          value: 150
        },
        {
          name: "沈阳",
          value: 150
        },
        {
          name: "北京",
          value: 150
        },
        {
          name: "济南",
          value: 150
        },
        {
          name: "郑州",
          value: 150
        },

        {
          name: "武汉",
          value: 150
        },
        {
          name: "南京",
          value: 150
        },
        {
          name: "上海",
          value: 150
        },
        {
          name: "杭州",
          value: 150
        },
        {
          name: "广州",
          value: 150
        },
        {
          name: "深圳",
          value: 150
        }
      ],
      // 地图经纬度数据
      geoCoordMap: {
        成都: [104.065735, 30.659462],
        西安: [108.948021, 34.263161],
        重庆: [106.504959, 29.533155],
        沈阳: [123.429092, 41.796768],
        北京: [116.405289, 39.904987],
        济南: [117.000923, 36.675808],
        郑州: [113.665413, 34.757977],
        武汉: [114.298569, 30.584354],
        南京: [118.76741, 32.041546],
        上海: [121.472641, 31.231707],
        杭州: [120.15358, 30.287458],
        广州: [113.28064, 23.125177],
        深圳: [114.0707, 22.3333],

        // 假数据
        海门: [121.15, 31.89],
        鄂尔多斯: [109.781327, 39.608266],
        招远: [120.38, 37.35],
        舟山: [122.207216, 29.985295],
        齐齐哈尔: [123.97, 47.33],
        盐城: [120.13, 33.38],
        赤峰: [118.87, 42.28],
        青岛: [120.33, 36.07],
        乳山: [121.52, 36.89],
        金昌: [102.188043, 38.520089],
        泉州: [118.58, 24.93],
        莱西: [120.53, 36.86],
        日照: [119.46, 35.42],
        胶南: [119.97, 35.88],
        南通: [121.05, 32.08],
        拉萨: [91.11, 29.97],
        云浮: [112.02, 22.93],
        梅州: [116.1, 24.55],
        文登: [122.05, 37.2],
        攀枝花: [101.718637, 26.582347],
        威海: [122.1, 37.5],
        承德: [117.93, 40.97],
        厦门: [118.1, 24.46],
        汕尾: [115.375279, 22.786211],
        潮州: [116.63, 23.68],
        丹东: [124.37, 40.13],
        太仓: [121.1, 31.45],
        曲靖: [103.79, 25.51],
        烟台: [121.39, 37.52],
        福州: [119.3, 26.08],
        瓦房店: [121.979603, 39.627114],
        即墨: [120.45, 36.38],
        抚顺: [123.97, 41.97],
        玉溪: [102.52, 24.35],
        张家口: [114.87, 40.82],
        阳泉: [113.57, 37.85],
        莱州: [119.942327, 37.177017],
        湖州: [120.1, 30.86],
        汕头: [116.69, 23.39],
        昆山: [120.95, 31.39],
        宁波: [121.56, 29.86],
        湛江: [110.359377, 21.270708],
        揭阳: [116.35, 23.55],
        荣成: [122.41, 37.16],
        连云港: [119.16, 34.59],
        葫芦岛: [120.836932, 40.711052],
        常熟: [120.74, 31.64],
        东莞: [113.75, 23.04],
        河源: [114.68, 23.73],
        淮安: [119.15, 33.5],
        泰州: [119.9, 32.49],
        南宁: [108.33, 22.84],
        营口: [122.18, 40.65],
        惠州: [114.4, 23.09],
        江阴: [120.26, 31.91],
        蓬莱: [120.75, 37.8],
        韶关: [113.62, 24.84],
        嘉峪关: [98.289152, 39.77313],
        延安: [109.47, 36.6],
        太原: [112.53, 37.87],
        清远: [113.01, 23.7],
        中山: [113.38, 22.52],
        昆明: [102.73, 25.04],
        寿光: [118.73, 36.86],
        盘锦: [122.070714, 41.119997],
        长治: [113.08, 36.18],
        珠海: [113.52, 22.3],
        宿迁: [118.3, 33.96],
        咸阳: [108.72, 34.36],
        铜川: [109.11, 35.09],
        平度: [119.97, 36.77],
        佛山: [113.11, 23.05],
        海口: [110.35, 20.02],
        江门: [113.06, 22.61],
        章丘: [117.53, 36.72],
        肇庆: [112.44, 23.05],
        大连: [121.62, 38.92],
        临汾: [111.5, 36.08],
        吴江: [120.63, 31.16],
        石嘴山: [106.39, 39.04],
        苏州: [120.62, 31.32],
        茂名: [110.88, 21.68],
        嘉兴: [120.76, 30.77],
        长春: [125.35, 43.88],
        胶州: [120.03336, 36.264622],
        银川: [106.27, 38.47],
        张家港: [120.555821, 31.875428],
        三门峡: [111.19, 34.76],
        锦州: [121.15, 41.13],
        南昌: [115.89, 28.68],
        柳州: [109.4, 24.33],
        三亚: [109.511909, 18.252847],
        自贡: [104.778442, 29.33903],
        吉林: [126.57, 43.87],
        阳江: [111.95, 21.85],
        泸州: [105.39, 28.91],
        西宁: [101.74, 36.56],
        宜宾: [104.56, 29.77],
        呼和浩特: [111.65, 40.82],
        大同: [113.3, 40.12],
        镇江: [119.44, 32.2],
        桂林: [110.28, 25.29],
        张家界: [110.479191, 29.117096],
        宜兴: [119.82, 31.36],
        北海: [109.12, 21.49],
        金坛: [119.56, 31.74],
        东营: [118.49, 37.46],
        牡丹江: [129.58, 44.6],
        遵义: [106.9, 27.7],
        绍兴: [120.58, 30.01],
        扬州: [119.42, 32.39],
        常州: [119.95, 31.79],
        潍坊: [119.1, 36.62],
        台州: [121.420757, 28.656386],
        滨州: [118.03, 37.36],
        贵阳: [106.71, 26.57],
        无锡: [120.29, 31.59],
        本溪: [123.73, 41.3],
        克拉玛依: [84.77, 45.59],
        渭南: [109.5, 34.52],
        马鞍山: [118.48, 31.56],
        宝鸡: [107.15, 34.38],
        焦作: [113.21, 35.24],
        句容: [119.16, 31.95],
        徐州: [117.2, 34.26],
        衡水: [115.72, 37.72],
        包头: [110, 40.58],
        绵阳: [104.73, 31.48],
        乌鲁木齐: [87.68, 43.77],
        枣庄: [117.57, 34.86],
        淄博: [118.05, 36.78],
        鞍山: [122.85, 41.12],
        溧阳: [119.48, 31.43],
        库尔勒: [86.06, 41.68],
        安阳: [114.35, 36.1],
        开封: [114.35, 34.79],
        德阳: [104.37, 31.13],
        温州: [120.65, 28.01],
        九江: [115.97, 29.71],
        邯郸: [114.47, 36.6],
        临安: [119.72, 30.23],
        兰州: [103.73, 36.03],
        沧州: [116.83, 38.33],
        临沂: [118.35, 35.05],
        南充: [106.110698, 30.837793],
        天津: [117.2, 39.13],
        富阳: [119.95, 30.07],
        泰安: [117.13, 36.18],
        诸暨: [120.23, 29.71],
        哈尔滨: [126.63, 45.75],
        聊城: [115.97, 36.45],
        芜湖: [118.38, 31.33],
        唐山: [118.02, 39.63],
        平顶山: [113.29, 33.75],
        邢台: [114.48, 37.05],
        德州: [116.29, 37.45],
        济宁: [116.59, 35.38],
        荆州: [112.239741, 30.335165],
        宜昌: [111.3, 30.7],
        义乌: [120.06, 29.32],
        丽水: [119.92, 28.45],
        洛阳: [112.44, 34.7],
        秦皇岛: [119.57, 39.95],
        株洲: [113.16, 27.83],
        石家庄: [114.48, 38.03],
        莱芜: [117.67, 36.19],
        常德: [111.69, 29.05],
        保定: [115.48, 38.85],
        湘潭: [112.91, 27.87],
        金华: [119.64, 29.12],
        岳阳: [113.09, 29.37],
        长沙: [113, 28.21],
        衢州: [118.88, 28.97],
        廊坊: [116.7, 39.53],
        菏泽: [115.480656, 35.23375],
        合肥: [117.27, 31.86],
        大庆: [125.03, 46.58]
      },
      // 视频计数器
      videoNum: 0,
      // 回收计数器
      recoveryNum: 0,
      // map计数器
      mapNum: 0,
      // new计数器
      newNum: 0,
      // 合作伙伴图片数组
      cooperativePartnerImg: [
        "https://p4.ssl.qhimg.com/t0143a6f9e25e103e0b.png",
        "https://p2.ssl.qhimg.com/t01e42dedc5181d10fc.png",
        "https://p3.ssl.qhimg.com/t0186a43f3d65461443.png",
        "https://p5.ssl.qhimg.com/t01ef4e25bae5822d5b.png",
        "https://p4.ssl.qhimg.com/t01576b968eb05406bb.png",
        "https://p1.ssl.qhimg.com/t01a2b707e29391ef45.png",
        "https://p3.ssl.qhimg.com/t01c2ac814a2b0fa70a.png",
        "https://p2.ssl.qhimg.com/t01faf60657be67f599.png",
        "https://p1.ssl.qhimg.com/t015cac87ddae6be170.png",
        "https://p2.ssl.qhimg.com/t018caacdde86d4a051.png",
        "https://p2.ssl.qhimg.com/t01a818a8460fe451cc.png",
        "https://p3.ssl.qhimg.com/t0108b3468134c19c4a.png"
      ]
    };
  },
  methods: {
    // 走马灯回调函数
    showIndex(index) {
      // console.log("被选中的索引", index);
      this.carouselIndex = index;
      // let dom=document.getElementsByClassName('el-carousel__container')
      // let dom = document.querySelectorAll(".el-carousel__item")[index];
      // console.log('之前的Dom',dom)
      // setTimeout(() => {
      //   dom.style.cssText="transform: translateX(300px) scale(0.83);"
      //         console.log('修改之后的DOM',dom)
      // }, 100);

      // dom.style.scale=0.8
      // dom.style.backgroundColor="red";
      // console.log('dom元素',dom)
    },
    // 回收增加边框
    addBorder(index) {
      this.recoveryData.forEach(item => (item.isShowBoeder = false));
      this.recoveryData[index].isShowBoeder = true;
    },
    // 鼠标移入
    onMouseEnter(index) {
      if (index == 0) {
        this.isHover1 = true;
      } else if (index == 1) {
        this.isHover2 = true;
      } else if (index == 2) {
        this.isHover3 = true;
      }
    },
    // 鼠标移出
    onMouseLeave(index) {
      if (index == 0 && this.showContentData[index].isHighlight == false) {
        this.isHover1 = false;
      } else if (
        index == 1 &&
        this.showContentData[index].isHighlight == false
      ) {
        this.isHover2 = false;
      } else if (
        index == 2 &&
        this.showContentData[index].isHighlight == false
      ) {
        this.isHover3 = false;
      }
    },
    // 鼠标点击信息框
    handeleClick(index) {
      this.isHover1 = false;
      this.isHover2 = false;
      this.isHover3 = false;
      if (index == 0) {
        this.isHover1 = true;
      } else if (index == 1) {
        this.isHover2 = true;
      } else if (index == 2) {
        this.isHover3 = true;
      }

      this.showContentData.forEach(item => (item.isHighlight = false));
      this.showContentData[index].isHighlight = true;
    },
    // 播放视频
    handlePlay() {
      this.$refs.videoPlayer.player.play();
      this.isShowBotton = false;
    },
    onPlayerPause() {
      this.isShowBotton = true;
    },
    onPlayerEnded() {
      this.isShowBotton = true;
    },
    onPlayerPlay() {
      // 设置音量
      // this.$refs.videoPlayer.player.volume(1)
      this.isShowBotton = false;
    },
    // 地图相关的方法
    convertData(data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var geoCoord = this.geoCoordMap[data[i].name];
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value)
          });
        }
      }
      return res;
    },
    // 地图的配置
    mapFn() {
      let option = {
        backgroundColor: "white",
        tooltip: {
          trigger: "item" //鼠标悬浮效果， 删除可以不显示悬浮框
        },

        geo: {
          show: true, //是否显示地理坐标系组件。
          roam: false, // 是否允许拖拽。
          map: "china",
          zoom: 1.2, //默认显示级别
          scaleLimit: { min: 0, max: 3 }, //缩放级别
          label: {
            show: false, //是否显示文本
            color: "red", //文本颜色
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "12"
          },
          itemStyle: {
            // 板块颜色 板块边框颜色
            normal: {
              areaColor: "#e6ebf2",
              borderColor: "white"
            }
            // emphasis: {
            //   // 板块选中的颜色
            //   areaColor: "#26C9A5",

            // }
          },
          //高亮状态下的多边形和标签样式。
          emphasis: {
            show: false, //悬浮显示该模块地名
            label: {
              //文本
              color: "#e6ebf2"
            },
            itemStyle: {
              //区域
              areaColor: "#e6ebf2"
            }
          }
        },
        series: [
          {
            type: "scatter",
            coordinateSystem: "geo",
            data: this.convertData(this.cityData),
            symbolSize: function(val) {
              return val[2] / 15;
            },
            label: {
              normal: {
                formatter: "",
                position: "right",
                show: true
              },
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                color: "skyblue"
              }
            },
            tooltip: {
              showContent: false
            }
          },
          {
            silent: false, //图形是否不响应和触发鼠标事件，默认为 false，即响应和触发鼠标事件
            name: "回收中心",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: this.convertData(
              this.cityData
                .sort(function(a, b) {
                  return b.value - a.value;
                })
                .slice(0, 13)
            ),
            symbolSize: function(val) {
              return val[2] / 15;
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke"
            },
            hoverAnimation: true,
            legendHoverLink: false,
            label: {
              normal: {
                // formatter: "{b}",
                formatter: "{b}",
                position: "right",
                show: true //小圆点的文字是否显示
              }
            },
            rippleEffect: {
              //涟漪特效
              period: 3, //特效动画时长
              scale: 3, //波纹的最大缩放比例
              brushType: "stroke" //波纹的绘制方式：stroke | fill
            },
            itemStyle: {
              // 点的颜色
              normal: {
                color: "#26C9A5",
                shadowBlur: 2,
                shadowColor: "white",

                label: {
                  // 点旁边的文字
                  textStyle: {
                    fontWeight: "bold", //字体
                    fontSize: 11, //字体大小
                    color: "#000000"
                  }
                }
              }
            },
            tooltip: {
              formatter: params => {
                for (let i = 0; i < this.cityData.length; i++) {
                  if (this.cityData[i].name === params.name) {
                    return (
                      '<div style="width: 100px; padding: 0px 5px"><p style="text-align: center;">' +
                      params.name +
                      "回收中心</p ><div>"
                    );
                  }
                }
              },
              showContent: true, //是否显示提示框浮层
              alwaysShowContent: false, //是否永远显示提示框内容
              position: "right"
            },
            zlevel: 1
          },
          {
            name: "111",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: this.convertData(
              this.cityData
                .sort(function(a, b) {
                  return b.value - a.value;
                })
                .slice(40, 80)
            ),
            symbolSize: function(val) {
              return val[1] / 15;
            },
            showEffectOn: "render",
            hoverAnimation: false,
            label: {
              normal: {
                // formatter: "{b}",
                formatter: "{a}", //提示内容为空
                position: "inside",
                show: false //小圆点的文字是否显示
              }
            },
            itemStyle: {
              // 点的颜色
              normal: {
                color: "#d2a2cc"
              }
            },
            tooltip: {
              showContent: false
            }
          },
          {
            name: "1111",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: this.convertData(
              this.cityData
                .sort(function(a, b) {
                  return b.value - a.value;
                })
                .slice(80, 110)
            ),
            symbolSize: function(val) {
              return val[1] / 15;
            },
            showEffectOn: "render",
            hoverAnimation: false,
            label: {
              normal: {
                // formatter: "{b}",
                formatter: "{a}", //提示内容为空
                position: "inside",
                show: false //小圆点的文字是否显示
              }
            },
            itemStyle: {
              // 点的颜色
              normal: {
                color: "#ff8f59"
              }
            },
            tooltip: {
              showContent: false
            }
          }
        ]
      };
      var myChart = this.$echarts.init(document.querySelector(".myEcharts"));
      myChart.setOption(option);
    },
    // 页面加载，监听滑动事件
    monitorScroll() {
      window.onscroll = () => {
        let videoWrap = document.querySelector(".videoWrap");
        let scrollTop = videoWrap.getBoundingClientRect().top;
        let pageHeight = document.documentElement.clientHeight;
        if (scrollTop < pageHeight && scrollTop > 0 && this.videoNum == 0) {
          this.$refs.videoPlayer.player.play();
          this.videoNum++;
        }

        let left = document.querySelector(".distributionInformation .left");
        let right = document.querySelector(".distributionInformation .right");
        let leftTop = left.getBoundingClientRect().top;
        let rightTop = right.getBoundingClientRect().top;
        if (leftTop < pageHeight - 100 && leftTop > 0 && this.mapNum == 0) {
          left.classList.add("animated", "fadeInLeft");
          right.classList.add("animated", "fadeInRight");
          this.mapNum++;
        }

        let ul = document.querySelector(".recoveryInformation-ul");
        let ulTop = ul.getBoundingClientRect().top;
        if (ulTop < pageHeight && ulTop > 0 && this.recoveryNum == 0) {
          ul.classList.add("recoveryInformationAnimation");
          this.recoveryNum++;
        }

        let ulNew = document.querySelector(".newsInformation-content");
        let ulNewTop = ulNew.getBoundingClientRect().top;
        if (ulNewTop < pageHeight && ulNewTop > 0 && this.newNum == 0) {
          ulNew.classList.add("newAnimation");
          this.newNum++;
        }

        if (
          this.newNum > 0 &&
          this.recoveryNum > 0 &&
          this.mapNum > 0 &&
          this.videoNum
        ) {
          window.onscroll = null;
        }
      };
    }
  },
  computed: {
    showContentObj() {
      // 第一种

      // let result= this.showContentData.forEach(item=>{
      //   if(item.isHighlight){
      //     console.log('!!!!!!!!!!',item)
      //     return item
      //   }

      //   })
      // 第二种
      return this.showContentData.filter(item => item.isHighlight == true);
    }
  },
  mounted() {
    // 让动画一直执行，给banner绑定事件
    var banner = document.querySelector(".banner");
    banner.addEventListener("animationend", function() {
      banner.classList.remove("animate");
    });
    // 初始化地图数据
    this.mapFn();
    // 绑定滚动事件
    this.monitorScroll();
    let _this = this;

    var Swiper2 = new Swiper(".content-img .swiper-container", {
      watchSlidesProgress: true,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      loopedSlides: 5,
      autoplay: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        // el: ".swiper-pagination",
        clickable: true
      },
      on: {
        progress: function(progress) {
          for (let i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i);
            var slideProgress = this.slides[i].progress;
            var modify = 1;
            if (Math.abs(slideProgress) > 1) {
              modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
            }
            var translate = slideProgress * modify * 260 + "px";
            var scale = 1 - Math.abs(slideProgress) / 5;
            var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
            slide.transform(
              "translateX(" + translate + ") scale(" + scale + ")"
            );
            slide.css("zIndex", zIndex);
            slide.css("opacity", 1);
            if (Math.abs(slideProgress) > 3) {
              slide.css("opacity", 0);
            }
          }
        },
        setTransition: function(transition) {
          for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i);
            slide.transition(transition);
          }
        },
        slideChange: function() {
          console.log("现在轮播索引", this.activeIndex);
          // _this.carouselIndex=Number(this.activeIndex)%6
          // // if(this.activeIndex==5){
          // //   this.activeIndex=6
          // // }
          // console.log("现在轮播索引", this.activeIndex); //切换结束时，告诉我现在是第几个slide
          // // if(this.activeIndex==5||this.activeIndex==6){
          // //   this.activeIndex=6
          // // }
          // // _this.carouselIndex = Number(this.activeIndex);
          // // if(_this.carouselIndex==-1){
          // //   _this.carouselIndex=0
          // // }
          // if(this.activeIndex>5){
          //    _this.carouselIndex=Number(this.activeIndex)-6
          // }
          // console.log("现在轮播索引", this.activeIndex);
          // if(this.activeIndex>5){
          //   _this.carouselIndex = Number(this.activeIndex)
          // }
        }
      }
    });
  },
  updated() {
    console.log("下方显示内容区索引", this.carouselIndex);
  },
  destroyed() {
    this.$bus.$emit("closeNave");
  }
};
</script>

<style lang="scss" scoped>
#wrap {
  // 公共样式
  .publicStyle-title {
    margin-bottom: 60px;
    div:first-child {
      margin-bottom: 21px;
      display: flex;
      span:first-child {
        width: 76px;
        height: 7px;
        background-color: #26c9a5;
        border-radius: 3.5px;
        display: inline-block;
        margin-right: 6px;
      }
      span:last-child {
        background-color: #26c9a5;
        width: 8px;
        height: 8px;
        display: inline-block;
        border-radius: 50%;
      }
    }
    div:last-child {
      color: #000000;
      font-size: 30px;
      font-weight: 600;
    }
  }
  // 轮播图区域
  .rotationChart {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    padding-bottom: 61px;
    // banner样式
    .banner {
      width: 730px;
      height: 410px;
      position: absolute;
      left: 582px;
      top: -60px;
      z-index: 2;
      background-image: url("https://p3.ssl.qhimg.com/t016eb6d5315858bc5b.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      // animation-name:move;
      // animation-duration:;
      // animation-delay: 5s;
      // animation-iteration-count:infinite;
    }
    .banner.animate {
      animation: move 0.5s;
    }
    @keyframes move {
      0% {
        opacity: 0;
        transform: translateX(50px);
      }
      100% {
        opacity: 1;
        transform: translateX(0);
      }
    }
    // 轮播图样式
    .mySwiper {
      position: relative;
      z-index: 3;
      .mySwiper-item {
        img {
          width: 100%;
          height: 480px;
        }
      }
    }
    // 轮播下方的文字
    .animate-top {
      animation: top 1s;
    }
    @keyframes top {
      0% {
        transform: translateY(130px);
      }
      100% {
        transform: translateY(0px);
      }
    }
    .displayBar {
      margin-top: 45px;
      display: flex;
      // position: relative;
      // left: 0;
      // top: 120px;
      transition: all 2s;

      div {
        width: 380px;
        height: 127px;
        background-color: #e9f9f6;
        margin-right: 33px;
        position: relative;
        padding: 24px 29px 0 81px;
        border-radius: 6px;
        box-sizing: border-box;
        img {
          width: 50px;
          height: 45px;
          position: absolute;
          left: 18px;
          bottom: 101px;
        }
        span:first-of-type {
          font-size: 16px;
          color: #03050e;
          display: block;
          font-weight: 600;
        }
        span:last-of-type {
          font-size: 14px;
          color: #666666;
          display: block;
          margin-top: 10px;
          // font-weight: 600;
        }
      }
    }
  }
  // 视频区域
  .showVideo-bg {
    background-color: #f9faff;
    .showVideo {
      width: 1200px;
      margin: 0 auto;
      padding: 60px 0;
      display: flex;
      .left {
        width: 593px;
        margin-right: 76px;
        // left-top 使用了公共样式
        .left-bottom {
          font-size: 16px;
          color: #666666;
          font-weight: 400;
          width: 593px;
          max-height: 200px;
          overflow: auto;
          line-height: 28px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 7;
          overflow: hidden;
        }
      }
      .right {
        width: 531px;
        height: 251px;
        // height: 203px;
        // background-color: pink;
        background-image: url("../../assets/imgs/sj.png");
        background-repeat: no-repeat;
        background-size: cover;
        margin-top: 25px;
        border-radius: 30px;
        position: relative;
        img {
          width: 68px;
          height: 68px;
          display: block;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
        .videoWrap {
          width: 500px;
          height: 220px;
          margin: auto;
          background-color: red;
          position: absolute;
          left: 16px;
          top: 16px;
          border-radius: 24px;
          overflow: hidden;
          .myVideo {
            width: 500px;
            height: 217px;
          }
        }
      }
    }
  }
  // 信息栏
  .informationBar {
    width: 1200px;
    margin: 0 auto;
    padding: 60px 0;
    // 点击区域
    .tabBar {
      display: flex;
      justify-content: space-around;
      margin-bottom: 25px;
      //公共样式
      .tabBar-public {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        div:first-child {
          width: 128px;
          height: 103px;
          position: relative;
          margin-bottom: 15px;
          img {
            display: block;
            margin: 0 auto;
            width: 42px;
            height: 57px;
            position: absolute;
            left: 0;
            bottom: 0;
            top: 0;
            right: 0;
            margin: auto;
          }
          > span {
            transition: all 1s;
            opacity: 1;
            position: absolute;
            top: 155%;
            left: 50%;
            transform: translate(-50%, -50%);
            display: block;
            border-bottom: 12px solid #26c9a5;
            border-top: 12px solid transparent;
            border-right: 12px solid transparent;
            border-left: 12px solid transparent;
          }
        }
        div:first-child:hover {
          background-image: url("../../assets/imgs/iconbj.png");
          > span {
            opacity: 1;
          }
        }
        //高亮
        .active {
          background-image: url("../../assets/imgs/iconbj.png");
          background-repeat: no-repeat;
          background-size: cover;
          > span {
            opacity: 1;
          }
        }
        div:last-child {
          text-align: center;
          color: #03050e;
          font-size: 22px;
          font-weight: 600;
        }
      }
      .tabBar-two,
      .tabBar-three {
        div:first-child {
          img {
            width: 51px;
            height: 51px;
          }
        }
      }
    }
    // 展示区域
    .showContent {
      display: flex;
      height: 442px;
      padding: 81px 85px 82px 80px;
      border-top: 1px solid #26c9a5;
      box-shadow: 2px 2px 15px #eee;
      box-sizing: border-box;
      .left {
        margin-right: 74px;
        img {
          width: 445px;
          height: 287px;
        }
      }
      .right {
        .title {
          color: #03050e;
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 30px;
        }
        .text {
          width: 515px;
          color: #666666;
          font-size: 16px;
          line-height: 30px;
        }
      }
    }
  }
  // 回收信息
  .recoveryInformation-bg {
    background-color: #f9faff;
    .recoveryInformation {
      width: 1200px;
      margin: 0 auto;
      padding: 60px 0;
      @keyframes ri-top {
        0% {
          transform: translateY(460px);
        }
        100% {
          transform: translateY(0px);
        }
      }
      .recoveryInformationAnimation {
        animation: ri-top 1s;
      }

      ul {
        display: flex;
        justify-content: space-between;
        li {
          width: 370px;
          min-height: 440px;
          padding: 2px;
          box-shadow: 0px 0px 10px #ccc;
          a {
            img {
              display: block;
              height: 265px;
              width: 370px;
            }
            // display: block;
            // width: 370px;
            // height: 265px;
            // background-image: url("../../assets/imgs//suningyigou.png");
            // background-repeat: no-repeat;
            // background-size: cover;
          }
          div:nth-child(1) {
            color: #000000;
            font-size: 20px;
            line-height: 23px;
            font-weight: 600;
            text-align: center;
            margin: 20px 0;
          }
          div:nth-child(2) {
            color: #666666;
            font-size: 14px;
            line-height: 25px;
            font-weight: 400;

            padding: 0 20px;
            box-sizing: border-box;
          }
        }
        li:hover {
          border: 1px solid #26c9a5;
          padding: 1px;
        }
        .showBorder {
          border: 1px solid #26c9a5;
          padding: 1px;
        }
      }
    }
  }
  // 分布信息
  .distributionInformation {
    width: 1200px;
    margin: 0 auto;
    padding: 60px 0;
    display: flex;
    .left {
      margin-right: 150px;
      .publicStyle-title {
        margin-bottom: 40px;
      }
      // 左边标题
      .left-title {
        color: #000000;
        font-size: 20px;
        line-height: 23px;
        margin-bottom: 150px;
        white-space: nowrap;
      }
      .left-content {
        display: flex;
        flex-wrap: wrap;
        width: 330px;
        li {
          display: flex;
          flex-direction: column;
          padding-right: 55px;
          margin-bottom: 65px;
          span:nth-child(1) {
            color: #000000;
            font-weight: 800;
            font-size: 32px;
            padding-bottom: 30px;
            span {
              color: #000000;
            }
          }
          span:nth-child(2) {
            color: #999999;
            font-weight: 600;
            font-size: 14px;
          }
          &:nth-child(4) {
            transform: translateX(15px);
          }
        }
      }
    }
    .right {
      width: 714px;
      height: 587px;
      // margin-left: 150px;
      margin-top: 15px;
      .myEcharts {
        width: 100%;
        height: 100%;
        // background-color: skyblue;
      }
    }
  }
  // 新闻动态
  .newsInformation-bg {
    background-color: #f9faff;
    .newsInformation {
      width: 1200px;
      margin: 0 auto;
      padding: 60px 0;
      @keyframes new-top {
        0% {
          transform: translateY(335px);
        }
        100% {
          transform: translateY(0px);
        }
      }
      .newAnimation {
        animation: new-top 1s;
      }
      .newsInformation-content {
        display: flex;
        flex-wrap: wrap;
        > li:nth-child(1),
        > li:nth-child(2) {
          margin-bottom: 30px;
        }
        > li:nth-child(2n + 1) {
          margin-right: 43px;
        }
        li {
          display: flex;
          div {
            img {
              width: 220px;
              height: 130px;
              display: block;
            }
          }
          .right {
            position: relative;
            padding: 8px 0 0 20px;
            li:nth-child(1) {
              color: #23262a;
              font-size: 16px;
              font-weight: 600;
              margin-bottom: 15px;
            }
            li:nth-child(2) {
              max-width: 314px;
              max-height: 60px;
              color: #666666;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              // padding: 20px 0 15px 0;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              box-sizing: border-box;
            }
            li:nth-child(3) {
              color: #999999;
              font-size: 14px;
              position: absolute;
              left: 20px;
              bottom: 4px;
              i {
                margin-right: 4px;
              }
            }
          }
        }
      }
    }
  }
  // 合作伙伴
  .cooperativePartner {
    width: 1200px;
    margin: 0 auto;
    padding: 60px 0;
    // 之前的样式  已经废除 暂时放在这 怕产品又改回来- -
    .content {
      height: 432px;
      // background: pink;
      padding-bottom: 70px;
      box-sizing: border-box;
      box-shadow: 2px 2px 15px #eee;
      position: relative;
      .content-img {
        height: 188px;
        .el-carousel__item h3 {
          color: #475669; //内容的颜色
          opacity: 0.75;
          line-height: 188px;
          margin: 0 auto;
          position: relative;
          img {
            display: block;
            position: absolute;
            left: 25%;
            bottom: -125px;
          }
        }
        .el-carousel__item {
          background-color: #fff;
        }
        .is-active {
          transform: translateX(300px) scale(0.75) !important;
        }

        // .el-carousel__item:nth-child(2n) {
        //   background-color: #fff; //偶数个颜色
        // }

        // .el-carousel__item:nth-child(2n + 1) {
        //   background-color: #f9faff; //奇数个颜色
        // }
      }
      .content-text {
        height: 174px;
        // background-color: yellowgreen;
        padding-top: 23px;
        box-sizing: border-box;
        text-align: center;
        > div:nth-child(1) {
          width: 758px;
          margin: 0 auto;
          // background-color: red;
          margin-bottom: 40px;
          height: 40px;
          //省略号
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        > div:nth-child(2) {
          height: 60px;
          width: 225px;
          margin: 0 auto;
          display: flex;
          position: relative;
          img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            margin-right: 24px;
          }
          > span {
            display: block;
            height: 37px;
            border-right: 1px solid #dadada;
            line-height: 60px;
            margin: auto 30px auto 0;
          }
          div {
            display: flex;
            flex-direction: column;
            color: #666666;
            span:first-child {
              margin-top: 5px;
              margin-bottom: 13px;
            }
          }
        }
        //
        .right,
        .left {
          position: absolute;
          height: 38px;
          width: 66px;

          background-repeat: no-repeat;
          background-size: cover;
        }
        .right {
          left: 111px;
          top: 188px;
          background-image: url("../../assets/imgs/分号左.png");
        }
        .left {
          right: 130px;
          top: 243px;
          background-image: url("../../assets/imgs/分号右.png");
        }
      }
    }

    // 现在的样式
    .cooperativePartner-content {
      width: 1194px;
      height: 193px;
      display: flex;
      flex-wrap: wrap;
      border-top: 1px solid #dadada;
      border-left: 1px solid #dadada;
      .img {
        width: 198px;
        height: 95px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #dadada;
        border-bottom: 1px solid #dadada;
      }
      .img:hover {
        background-color: #f9faff;
      }
    }
  }
}
</style>

<style lang="scss">
// 视频按钮样式
.videoWrap {
  .vjs-custom-skin > .video-js .vjs-big-play-button {
    display: none;
    opacity: 0;
  }
  .vjs_video_3-dimensions.vjs-fluid {
    padding-top: 220px;
  }
}

// 轮播图小圆点样式#26C9A5
.swiper-pagination-bullet-active {
  background-color: #26c9a5 !important;
}
</style>
